import {ROOT_URL} from '../../config';
import request from '../../components/api/api';
import {fetchedPages, searchByTitle} from './actions';

export function onSearchPages(searchBy, siteId, getAllReviewPages = false) {
    return (dispatch, getState) => {
        return new Promise((resolve, reject) => {
            dispatch(searchByTitle(searchBy));
            resolve();
        }).then(() => {
            dispatch(debouncedSearchPages(searchBy, siteId, getAllReviewPages));
        });
    };
}

export function debouncedSearchPages(searchBy, siteId, getAllReviewPages) {
    const thunk = (dispatch) => {
        let url = `${ROOT_URL}/pages?site_id=${siteId}&title=${encodeURIComponent(
            searchBy
        )}&_limit=20`;
        if (getAllReviewPages) {
            url += '&reviews=all';
        }
        let options = {
            url,
            method: 'GET',
        };

        return request(options, dispatch).then((response) => {
            dispatch(fetchedPages(response.data));
        });
    };

    thunk.meta = {
        debounce: {
            time: 500,
            key: 'TRACK_CUSTOMER_SEARCH',
        },
    };

    return thunk;
}



// WEBPACK FOOTER //
// ./src/containers/page-picker/thunks.js